import React from 'react'
import { FaStar } from "react-icons/fa";
import { format } from 'date-fns';

const CompletedCourseFeedback = ({ FeedbackDetails, CourseDates }) => {
    console.log("FeedbackDetails in CompletedCourseFeedback is:",FeedbackDetails)
    console.log("CourseDates in CompletedCourseFeedback is:",CourseDates)

    // Extract CourseRating from the first object in FeedbackDetails
    const rating = FeedbackDetails?.[0]?.CourseRating || 0;

    // Extract StartDate and EndDate, ensuring they exist
    const startDate = CourseDates?.StartDate ? format(new Date(CourseDates.StartDate), "dd-MM-yyyy") : "N/A";
    const endDate = CourseDates?.EndDate ? format(new Date(CourseDates.EndDate), "dd-MM-yyyy") : "N/A";

    return(
        <div className='h-[205px] w-[30%] mt-[10px] lg:mt-[0px]'>
            <div className="flex flex-col justify-between h-full">
                <div className='flex flex-col gap-[10px]'>
                    <p className='text-[20px] text-[#000000]'>My Rating To The Course</p>
                    <div className='flex w-[85%] justify-end '>
                    {[...Array(rating)].map((_, index) => (
                            <FaStar
                                key={index}
                                className="text-[25px] text-[#A1A3EF]"
                            />
                        ))}
                    </div>
                </div>

                <div className='flex flex-col gap-[10px]'>
                    <p className='text-[20px] text-[#000000]'>Course Start - Finish</p>
                    <p className='text-[20px] text-[#000000] font-bold'>{startDate} - {endDate}</p>
                </div>
            </div>
        </div>
    )
}

export default CompletedCourseFeedback;
